import { render } from "./ModalConsultarReserva.vue?vue&type=template&id=27ac7a5e&scoped=true"
import script from "./ModalConsultarReserva.vue?vue&type=script&lang=js"
export * from "./ModalConsultarReserva.vue?vue&type=script&lang=js"

import "./ModalConsultarReserva.vue?vue&type=style&index=0&id=27ac7a5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ac7a5e"]])

export default __exports__